import { combineReducers } from '@reduxjs/toolkit';
import { clientsSlice } from '../clients/clientsSlice';
import { lendersSlice } from '../lenders/lendersSlice';
import { usersReducer } from './allUsers/reducer';
import { clientOverviewSlice } from '../client/clientOverviewSlice';

export const usersCollectionReducer = combineReducers({
  allUsers: usersReducer.reducer,
  lenders: lendersSlice.reducer,
  clients: clientsSlice.reducer,
  clientOverview: clientOverviewSlice.reducer,
});
